/** Region for HTTPS and callables on project m2b-tools. */
export const FUNCTIONS_REGION = 'europe-west1';

/**
 * Browser origin for HTTPS Cloud Functions.
 * Dev uses the CRA proxy (`/maptodo-api`) so CORS is not needed from localhost.
 */
export function cloudFunctionsOrigin() {
  if (process.env.NODE_ENV === 'development') {
    return '/maptodo-api';
  }
  return `https://${FUNCTIONS_REGION}-m2b-tools.cloudfunctions.net`;
}
